import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Layout from "../components/layout"
import HeroImage from "../components/heroImage"
import SEO from "../components/seo"
import GiftSyorui from "../components/giftDetail/giftSyorui"
import GiftCost from "../components/giftDetail/giftCost"
import GiftTax from "../components/giftDetail/giftTax"
import BackContact from "../components/backContact"
import BlogLink from "../components/blogLink"

const Zouyo = ({ location }) => {
  const data = useStaticQuery(graphql`
    query {
      gift: file(relativePath: { eq: "gift.jpeg" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
          original {
            height
            src
            width
          }
        }
      }
    }
  `)

  const description =
    "不動産の贈与の手続きや費用例、その他に税の特例について、大阪の司法書士事務所である司法書士法人みつわ合同事務所がご紹介します。"

  return (
    <Layout>
      <SEO
        description={description}
        title="贈与登記　名義変更の登記 | 司法書士　大阪"
        pagepath={location.pathname}
        pageimg={data.gift.childImageSharp.original.src}
        pageimgw={data.gift.childImageSharp.original.width}
        pageimgh={data.gift.childImageSharp.original.height}
      />
      <div className="main__container">
        <HeroImage
          name={"gift"}
          fluid={data.gift.childImageSharp.fluid}
          title={"司法書士法人みつわ合同事務所"}
          subTitle={"贈与登記"}
        />
        <section className="gift">
          <div className="gift__container">
            <h1 className="gift__title">贈与登記</h1>
            <GiftSyorui />
            <GiftCost />
            <GiftTax />
            <BlogLink link={"gift"} linkName={"贈与"} />
          </div>
        </section>
        <BackContact link={"/regist/"} linkName={"戻る"} />
      </div>
    </Layout>
  )
}

export default Zouyo
